export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9638.a2e8b313.jpg";